import { ProcessEachPayment } from './ProcessEachPayment';
export default ProcessEachPayment;